/*
 * @Date: 2020-03-17 11:34:57
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-04-07 11:10:46
 * @FilePath: \st-teacher-2020\src\service\common\common-url.ts
 */
// const baseUrl = process.env.VUE_APP_BASEURL;
const baseUrlChange = process.env.VUE_APP_BASEURL_CHANGE;
// const homeUrlChange = process.env.VUE_APP_HOMEURL;

export default {
  // 获取管理员列表
  getAdminList: `${baseUrlChange}/common/adminAndEducational`,
  // 获取小禾权限
  getXiaoheAuth: '//home.aixuexi.com/Hulk/axg/permission/check',
  // 调研问卷
  getQuestionnaire: '//home.aixuexi.com/Hulk/questionnaire/getByPosition',
  // 调研问卷
  submitQuestionnaire: '//home.aixuexi.com/Hulk/questionnaire/submit',
  // 空接口，每5分钟轮询一下接口，防止用户信息被盗用
  maintainLogin: `${baseUrlChange}/common/maintainLogin`,
  // 获取弹框列表
  getOption: `${baseUrlChange}/popup/options`,
  // 更新操作记录
  saveOption: `${baseUrlChange}/popup/saveOption`,
  // 存储授权签名信息
  getStorageSignature: `${baseUrlChange}/token/getToken`,
  // getStorageSignatures: '//home.aixuexi.com/Hulk/app/teaching/v1/getToken',
};
